<template>
  <div class="pc">
    <HeadTop></HeadTop>
    <div class="n-config-provider">
      <div class="">
        <div data-v-09672a82="" class="topup pc_container">
          <div data-v-05cd39fb="" data-v-09672a82="" class="userinfo user_topup">
            <div data-v-05cd39fb="" class="info">
              <img data-v-05cd39fb="" crossorigin="anonymous" referrer="no-referrer" src="../../static/xm.png" alt="" class="avatar" />
              <div data-v-05cd39fb="" class="middle">
                <p data-v-05cd39fb="" class="name">{{ info.email }}</p>
                <p data-v-05cd39fb="" class="uid visitor">ID:{{ info.uid }}</p>
              </div>
              <!-- <button data-v-05cd39fb="" class="signin">{{ $t('_m._tcdl') }}</button> -->
            </div>
            <!---->
            <div data-v-987dac3c="" data-v-05cd39fb="" class="wallet-header" style="justify-content: space-between">
              <div data-v-987dac3c="" class="wallet-header-right">
                <div data-v-987dac3c="" class="coins">
                  <span data-v-987dac3c="" class="number">${{ wallet.balance }}</span>
                  <div data-v-987dac3c="" class="coins-logo">
                    <div data-v-987dac3c="" class="logo oss-image-wrapper logo log1a"></div>
                    <span data-v-987dac3c="" class="text">{{ $t('_h._ye') }}</span>
                  </div>
                </div>
                <div data-v-987dac3c="" class="bonus">
                  <span data-v-987dac3c="" class="number">${{ wallet.freeze }}</span>
                  <div data-v-987dac3c="" class="bonus-logo">
                    <div data-v-987dac3c="" class="logo oss-image-wrapper logo log2a"></div>
                    <span data-v-987dac3c="" class="text">{{ $t('_h._dj') }}</span>
                  </div>
                </div>
              </div>
              <div data-v-987dac3c="" class="wallet-header-right">
                <div data-v-987dac3c="" class="coins">
                  <span data-v-987dac3c="" class="number">${{ wallet.video }}</span>
                  <div data-v-987dac3c="" class="coins-logo">
                    <div data-v-987dac3c="" class="logo oss-image-wrapper logo log1a"></div>
                    <span data-v-987dac3c="" class="text">{{ $t('_sp._dbye') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!---->
            <!-- <button data-v-05cd39fb="" class="topup_btn row">TOP UP</button> -->
            <div data-v-05cd39fb="" class="line"></div>
          </div>
          <!-- 视图 -->
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/base/head.vue'
export default {
  name: 'videoVue',
  components: {
    HeadTop
  },
  data() {
    return {
      wallet: {},
      info: {}
    }
  },
  created() {
    this.getInfo()
    this.getWallet()
  },
  methods: {
    getInfo() {
      this.info = this.$common.getInfo()
    },
    getWallet() {
      var hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      let that = this
      this.$api.userWallet.getWallet().then((res) => {
        hide()
        if (res.data.length <= 0) {
          that.$message.error('error')
          return
        }
        that.wallet = res.data
      })
    }
  }
}
</script>

<style>
.log1a {
  background: url('@/static/img/coins.png') center top / 100% no-repeat;
}
.log2a {
  background: url('@/static/img/bonus.png') center top / 100% no-repeat;
}
</style>
